<template>
  <div class="column">
    <div class="team-member-list-container">
      <h3 class="title is-3">Team Members</h3>
      <input
        class='button'
        :class="{ 'is-active': editing }"
        type='button'
        value="edit"
        @click="$emit('editing')"
        />

    </div>
    <ul class="team-list">
      <li
        v-if="team.members.length > 0"
        class="flex-space-between panel-block"
        v-for="member in team.members">

        {{ member.name || member.email }} <span v-if="member.is_coach" class="tag is-rounded is-primary">Coach</span><span v-if="member.is_group_admin" class="tag is-rounded is-warning">Admin</span>
        <input
          v-if="editing"
          @click='removeUser(team.id, member.id)'
          class='button is-small is-danger'
          type='button'
          value='remove'
          name='remove'/>

      </li>
    </ul>
    <p v-if="team.members.length === 0 && team.expanded">
      No members in this team.
    </p>
  </div>
</template>

<script>
import store from '../store.js'

export default {
  name: 'TeamMemberList',
  props: {
    team: {
      type: Object,
      required: true,
    },
    editing: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    removeUser (teamID, userID) {
      store.dispatch('removeUserFromTeam', { teamID, userID })
    },
  },
}
</script>

<style lang="scss" scoped>

.team-member-list-container {
  margin-top: 1rem;
  display: flex;
  justify-content: space-between;
}

</style>



// WEBPACK FOOTER //
// TeamMemberList.vue?037934b6